import React, { useEffect, useState } from "react";
import "./Header.css";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  // Empêcher le scroll du body quand le menu mobile est ouvert
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    // Cleanup
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isMobileMenuOpen]);

  // Fermer le menu mobile avec la touche Échap
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape" && isMobileMenuOpen) {
        closeMobileMenu();
      }
    };

    if (isMobileMenuOpen) {
      document.addEventListener("keydown", handleEscape);
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isMobileMenuOpen]);

  return (
    <>
      <header className={`header ${isScrolled ? "header--scrolled" : ""}`}>
        <div className="container">
          <div className="header__content flex flex--between">
            <div
              className="header__logo"
              onClick={() => (window.location.href = "#accueil")}
            >
              <h2 className="text-primary">🐔 Chiesugu</h2>
            </div>

            <nav className="header__nav">
              <ul className="header__nav-list flex">
                <li>
                  <a href="#accueil" className="header__nav-link">
                    Accueil
                  </a>
                </li>
                <li>
                  <a href="#fonctionnalites" className="header__nav-link">
                    Fonctionnalités
                  </a>
                </li>
                <li>
                  <a href="#galerie" className="header__nav-link">
                    Galerie
                  </a>
                </li>
                <li>
                  <a href="#contact" className="header__nav-link">
                    Restez à l'écoute
                  </a>
                </li>
              </ul>
            </nav>

            <div className="header__cta">
              <a href="#telecharger" className="btn btn--primary">
                Télécharger l'app
              </a>
            </div>

            {/* Bouton hamburger pour mobile */}
            <button
              className={`header__hamburger ${
                isMobileMenuOpen ? "header__hamburger--active" : ""
              }`}
              onClick={toggleMobileMenu}
              aria-label={
                isMobileMenuOpen ? "Fermer le menu" : "Ouvrir le menu"
              }
              aria-expanded={isMobileMenuOpen}
              aria-controls="mobile-menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </header>

      {/* Menu mobile overlay */}
      <div
        className={`mobile-menu ${isMobileMenuOpen ? "mobile-menu--open" : ""}`}
        id="mobile-menu"
        role="dialog"
        aria-modal="true"
        aria-label="Menu de navigation"
      >
        <div className="mobile-menu__overlay" onClick={closeMobileMenu}></div>
        <div className="mobile-menu__content">
          <nav
            className="mobile-menu__nav"
            role="navigation"
            aria-label="Menu principal"
          >
            <ul className="mobile-menu__nav-list">
              <li>
                <a
                  href="#accueil"
                  className="mobile-menu__nav-link"
                  onClick={closeMobileMenu}
                >
                  Accueil
                </a>
              </li>
              <li>
                <a
                  href="#fonctionnalites"
                  className="mobile-menu__nav-link"
                  onClick={closeMobileMenu}
                >
                  Fonctionnalités
                </a>
              </li>
              <li>
                <a
                  href="#galerie"
                  className="mobile-menu__nav-link"
                  onClick={closeMobileMenu}
                >
                  Galerie
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  className="mobile-menu__nav-link"
                  onClick={closeMobileMenu}
                >
                  Restez à l'écoute
                </a>
              </li>
            </ul>

            <div className="mobile-menu__cta">
              <a
                href="#telecharger"
                className="btn btn--primary btn--large"
                onClick={closeMobileMenu}
              >
                Télécharger l'app
              </a>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Header;
